import {AfterContentChecked, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ClienteComponent} from '../../components/cliente/cliente.component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PageService} from '../services/page.service';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {ObservacionModalComponent} from '../modal/observacion-modal/observacion-modal.component';
import Swal from 'sweetalert2';
import {ModalInjectorService} from '../services/modal-injector.service';
import {NumPedidoModalComponent} from '../modal/num-pedido-modal/num-pedido-modal.component';

@Component({
  selector: 'app-distintivo',
  templateUrl: './distintivo.component.html',
  styleUrls: ['./distintivo.component.css']
})
export class DistintivoComponent implements OnInit, AfterContentChecked {
  @ViewChild('clienteComprador', {static: false}) cliente: ClienteComponent;
  datosVehiculos: FormGroup;
  documentos: FormGroup;
  DatoCliente: any;
  isEditable = true;
  solicitud: string;
  title: string;
  formData: FormData;
  observacion: string;
  distintivo: any;
  activar = false;

  constructor(private cdRef: ChangeDetectorRef, private fb: FormBuilder, private servicio: PageService,
              private router: Router, public dialog: MatDialog, private modalInjector: ModalInjectorService) {
  }

  ngOnInit(): void {
    this.inicio();
    this.numPedidoModal();
  }

  numPedidoModal(): void{
    const dialogRef2 = this.dialog.open(NumPedidoModalComponent, {
      width: '400px',

      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog'
    });
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  get datosCliente(): any {
    return this.cliente ? this.cliente.cliente$ : null;
  }

  get bastidorNoValido(): any {
    return this.datosVehiculos.get('bastidor').invalid && this.datosVehiculos.get('bastidor').touched;
  }

  get matriculaNoValido(): any {
    return this.datosVehiculos.get('matricula').invalid && this.datosVehiculos.get('matricula').touched;
  }

  inicio(): void {
    this.solicitud = sessionStorage.getItem('id');
    sessionStorage.setItem('tipoCliente', '1');
    if (sessionStorage.getItem('colaborador') === 'null') {
      this.router.navigate(['page/home']);
    }
    this.crearFormulario();
    if (this.solicitud !== 'null') {
      console.log('aca');
      this.getSolicitud();
    }
  }

  crearFormulario(): any {
    this.datosVehiculos = this.fb.group({
      tipo: '',
      colaborador: '',
      usuarioweb: '',
      bastidor: ['', [Validators.required]],
      matricula: ['', [Validators.required]],
      observaciones: '',
    });

  }

  getSolicitud(): any {
    this.servicio.getOneSolicitud(this.solicitud).subscribe((res) => {
      this.setDatos(res);
    }, (error) => {
      console.log(error);
    });
  }

  getVehiculo(): void {
    if (this.datosVehiculos.value.matricula.length > 5) {
      this.servicio.getOneVehiculo(this.datosVehiculos.value.matricula).subscribe((res) => {
        if (res.matricula === this.datosVehiculos.value.matricula) {
          if (res.vehiculo != null) {
            console.log(res);
            this.setDatos(res.vehiculo);
          } else {
            this.datosVehiculos.setValue({
              tipo: '',
              colaborador: '',
              usuarioweb: '',
              bastidor: '',
              matricula: this.datosVehiculos.value.matricula,
              observaciones: '',
            });
          }
        }
      }, (error) => {
        console.log(error);
      });
      this.getDistintivo(this.datosVehiculos.value.matricula);
    } else {
      this.datosVehiculos.setValue({
        tipo: '',
        colaborador: '',
        usuarioweb: '',
        bastidor: '',
        matricula: this.datosVehiculos.value.matricula,
        observaciones: '',
      });
    }
  }

  getDistintivo(matricula): void {
    this.servicio.getDistintivo(matricula).subscribe((res) => {
      console.log(res);
      if (res !== 'NO DISTINTIVO') {
        this.distintivo = res.img;
        this.activar = true;
      } else {
        this.activar = false;
      }
    }, (error) => {
      console.log(error);
    });
  }

  setDatos(datos): any {
    this.datosVehiculos.controls.bastidor.setValue(datos.bastidor);
    this.datosVehiculos.controls.matricula.setValue(datos.matricula);
    this.getDistintivo(datos.matricula);
  }

  siguiente(): any {
    console.log(this.datosVehiculos.value);
  }

  siguiente2($event: any): void {
    this.DatoCliente = {...$event, ...this.datosVehiculos.value};
    this.DatoCliente.tipo = 'DISTINTIVO AMBIENTAL';
    this.DatoCliente.numPedido = sessionStorage.getItem('numPedidoComun');
    this.DatoCliente.colaborador = sessionStorage.getItem('colaborador');
    this.DatoCliente.usuarioweb = sessionStorage.getItem('email');
    console.log(this.DatoCliente);
  }


}
